'use strict';

angular.module('chatEngine.resources', ['ngResource'])
    .factory('Engine', ['$resource', function($resource) {
        var Engine = $resource('/api/v1/engine/:id', {id: '@id'}, {
            setDefault: {
                params: {id: '@id'},
                method: 'PUT',
                url: '/api/v1/engine/:id/default'
            },
            update: {method: 'PUT', params: {id: '@id'}}
        });

        // ensure that the ID parameter is present
        (function(oldUpdateFn, oldSetDefaultFn) {
            Engine.update = ensureIdPresent(oldUpdateFn);
            Engine.setDefault = ensureIdPresent(oldSetDefaultFn);

            function ensureIdPresent(fn) {
                return function(data) {
                    if (data.id) {
                        fn.apply(Engine, Array.prototype.slice.call(arguments));
                    } else {
                        throw 'missing required parameter "id"';
                    }
                };
            }
        })(Engine.update, Engine.setDefault);

        // map: engine id -> engine data from server
        var data = {};
        var meta = {
            keyword: {
                order: 1,
                title: 'Keyword Engine',
                type: 'keyword',
                description: 'Automatically respond with relevant content based on keywords',
                icon: 'assets/img/keyword-engine@2x.png',
                configureDescription: 'You must set an automatic reply before activating.'
            },
            custom: {
                order: 2,
                title: 'Custom Engine',
                type: 'custom',
                description: 'Develop a custom chat experience by building your own web service that uses our API',
                icon: 'assets/img/custom-engine@2x.png',
                configureDescription: 'You must enter a valid webhook URL before activating.'
            }
        };

        Engine.setData = function(engines) {
            engines = engines || [];
            for (var i = 0; i < engines.length; i++) {
                data[engines[i].id] = engines[i];
            }
            return data;
        };

        Engine.setDataWithEngine = function(engineData) {
            if(engineData !== null) {
                data[engineData.id] = engineData;
            }
            return data;
        };

        Engine.getData = function() {
            return data;
        };

        Engine.getMeta = function() {
            return meta;
        };

        Engine.getMetaById = function(id) {
            if(typeof data[id] !== 'undefined') {
                return Engine.getMetaByType(data[id].type);
            }
            return null;
        };

        Engine.getMetaByType = function(type) {
            return meta[type] || null;
        };

        Engine.getDataById = function(id) {
            return data[id] || null;
        };

        Engine.getDefaultEngine = function() {
            for (var engineId in data) {
                if(data.hasOwnProperty(engineId)) {
                    var engineData = data[engineId];
                    if (engineData.default === true) {
                        return engineData;
                    }
                }
            }
            return null;
        };

        Engine.getDataByType = function(engineType) {
            for (var engineId in data) {
                if(data.hasOwnProperty(engineId)) {
                    var engineData = data[engineId];
                    if (engineData.type === engineType) {
                        return engineData;
                    }
                }
            }
            return null;
        };

        Engine.reset = function() {
            data = {};
        };

        return Engine;
    }]
);
